import { createContext } from "react"
import { DefaultSupportPartnerInterface, SupportPartnerInterface } from "../../types"

export interface ShowSupportPartnersInterface {
  showSuccessMsg: boolean,  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean,  setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean, setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedSupportAss: SupportPartnerInterface, setSelectedSupportAss: (selectedSupportAss: SupportPartnerInterface) => void,
}

export const DefaultShowSupportPartnersInterface:ShowSupportPartnersInterface = {
  showSuccessMsg: false,  setShowSuccessMsg: () => {},
  showAddModal: false,  setShowAddModal: () => {},
  showEditModal: false, setShowEditModal: () => {},
  showDeleteModal: false,   setShowDeleteModal: () => {},
  selectedSupportAss: DefaultSupportPartnerInterface, setSelectedSupportAss: () => {},
}

export const ShowSupportPartnersContext = createContext<ShowSupportPartnersInterface>(DefaultShowSupportPartnersInterface)

export interface DataSupportPartner {
  amount: string, setAmount: (amount: string) => void,
  createdAt: string, setCreatedAt: (createdAt: string) => void,
}

export const DefaultDataSupportPartner: DataSupportPartner = {
  amount: "", setAmount: () => {},
  createdAt: "", setCreatedAt: () => {},
}

export const DataSupportPartnerContext = createContext<DataSupportPartner>(DefaultDataSupportPartner)
